module.exports = __webpack_public_path__ + "static/ex1-d0dbab98b7e08ee4c674c1948a0c177b.png";